import {isValidImei} from '../../components/imei';

/** Empty optional slots never become aliases or invalidate a single-IMEI model. */
export function stockInImeiState(values:string[],required:number){
 const captured=values.filter(value=>value!=='');
 const duplicates=captured.filter((value,index)=>captured.indexOf(value)!==index);
 const valid=captured.length>0&&captured.every(value=>isValidImei(value))&&duplicates.length===0;
 return {captured,duplicates,valid,complete:valid&&captured.length>=required,missing:Math.max(required-captured.length,0)};
}
